import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section id="about" className="py-20 md:py-32 bg-brand-blush" data-id="element-181">
      <div className="container mx-auto px-4 md:px-6" data-id="element-182">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-184">
            <div className="relative" data-id="element-185">
              <div className="absolute -inset-4 border-2 border-brand-teal rounded-tl-3xl rounded-br-3xl opacity-50 transform translate-x-4 translate-y-4" data-id="element-186"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mLTsDKnQoPkB2CB8jfs7NF/kbella_about_karen.webp" alt="Karen Dulong - Owner of K'Bella Spa & Wellness" className="relative z-10 w-full h-auto object-cover rounded-tl-3xl rounded-br-3xl shadow-xl" data-id="element-187" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-188">
            <div className="w-16 h-1 bg-brand-teal mb-6" data-id="element-189"></div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-6" data-id="element-190">
              Welcome to K'Bella Spa & Wellness
            </h2>
            <div className="space-y-6 text-brand-charcoal/80 text-lg leading-relaxed" data-id="element-191">
              <p data-id="element-192">
                For over 16 years, K'Bella Spa & Wellness has been Maricopa's
                most trusted destination for advanced skincare, permanent
                makeup, and total rejuvenation.
              </p>
              <p data-id="element-193">
                Founded by Karen Dulong — a licensed esthetician, PMU
                technician, and certified laser specialist — every treatment is
                fully customized using the highest-quality products, modern
                technology, and years of professional expertise.
              </p>
              <p data-id="element-194">
                At K'Bella, you're not just booking a service — you're stepping
                into a space where you feel seen, valued, and beautifully cared
                for.
              </p>
            </div>
            <div className="mt-10" data-id="element-195">
              <a href="#contact" className="inline-flex items-center text-brand-teal font-semibold text-lg hover:text-teal-600 transition-colors group" data-id="element-196">
                Meet Karen
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-197">
                  →
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}